"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVCard = exports.validateVCardOption = void 0;
const tslib_1 = require("tslib");
const vcard_creator_1 = tslib_1.__importDefault(require("vcard-creator"));
const vcard_utils_1 = require("./vcard-utils");
function validateVCardOption({ dateOfBirth, jobTitle, website, email, firstName, lastName, phone, }) {
    if (!(firstName || lastName || phone || email || jobTitle)) {
        return ['It needs to contain at least one of required fields'];
    }
    return [
        (0, vcard_utils_1.validateDateOfBirthday)(dateOfBirth),
        (0, vcard_utils_1.validateEmail)(email),
        (0, vcard_utils_1.validateUrl)(website),
    ].filter(Boolean);
}
exports.validateVCardOption = validateVCardOption;
function createVCard({ address, company, email, firstName, lastName, phone, website, dateOfBirth, jobTitle, }) {
    const vCard = new vcard_creator_1.default();
    vCard.addName(lastName, firstName, '', '', '');
    // Add work data
    company && vCard.addCompany(company);
    jobTitle && vCard.addJobtitle(jobTitle);
    email && vCard.addEmail(email);
    phone && vCard.addPhoneNumber(phone);
    address &&
        vCard.addAddress(address === null || address === void 0 ? void 0 : address.house, '', address === null || address === void 0 ? void 0 : address.street, address === null || address === void 0 ? void 0 : address.city, address === null || address === void 0 ? void 0 : address.region, address === null || address === void 0 ? void 0 : address.zip, address === null || address === void 0 ? void 0 : address.country, address === null || address === void 0 ? void 0 : address.type);
    website && vCard.addURL(website);
    dateOfBirth && vCard.addBirthday(dateOfBirth);
    return vCard
        .toString()
        .split('\n')
        .filter((line) => !line.startsWith('REV:') && !!line) // remove REVISION TAG
        .map((item) => item.trim())
        .join('\n');
}
exports.createVCard = createVCard;
//# sourceMappingURL=vcard.js.map